import { round, compare } from "./.fable/fable-library.3.1.16/Util.js";
import { skip, truncate, tryHead, iterateIndexed, tail, head as head_1 } from "./.fable/fable-library.3.1.16/Array.js";
import { Union } from "./.fable/fable-library.3.1.16/Types.js";
import { union_type } from "./.fable/fable-library.3.1.16/Reflection.js";
import { iterate } from "./.fable/fable-library.3.1.16/Seq.js";
import { toArray } from "./.fable/fable-library.3.1.16/Option.js";
import { printf, toText } from "./.fable/fable-library.3.1.16/String.js";
import { ScopeState } from "./Model.js";

export const zero32 = 0;

const sampleCount = (arg) => (1 * arg.length);

function isBetween(low, high, value) {
    if ((compare(low, value) <= 0) ? (compare(high, value) >= 0) : false) {
        return compare(low, high) < 0;
    }
    else {
        return false;
    }
}

function trimToRisingEdge(max_mut, data_mut) {
    trimToRisingEdge:
    while (true) {
        const max = max_mut, data = data_mut;
        if (data.length < 2) {
            return data;
        }
        else if (isBetween(head_1(data), head_1(tail(data)), zero32) ? (sampleCount(data) <= max) : false) {
            return tail(data);
        }
        else {
            max_mut = max;
            data_mut = tail(data);
            continue trimToRisingEdge;
        }
        break;
    }
}

export function toF(x) {
    return ((value) => value)(x);
}

export function toI(x) {
    return round(x);
}

export class Context2D_LineCap extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Butt", "Round", "Square"];
    }
}

export function Context2D_LineCap$reflection() {
    return union_type("Patchy.Client.Scope.Context2D.LineCap", [], Context2D_LineCap, () => [[], [], []]);
}

export class Context2D_LineJoin extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Bevel", "Round", "Miter"];
    }
}

export function Context2D_LineJoin$reflection() {
    return union_type("Patchy.Client.Scope.Context2D.LineJoin", [], Context2D_LineJoin, () => [[], [], []]);
}

export function Context2D_lineWidth(width, ctx) {
    ctx.lineWidth = width;
    return ctx;
}

export function Context2D_lineTo(_arg1_0, _arg1_1, ctx) {
    const _arg1 = [_arg1_0, _arg1_1];
    ctx.lineTo(_arg1[0], _arg1[1]);
    return ctx;
}

export function Context2D_moveTo(_arg1_0, _arg1_1, ctx) {
    const _arg1 = [_arg1_0, _arg1_1];
    ctx.moveTo(_arg1[0], _arg1[1]);
    return ctx;
}

export function Context2D_clearRect(_arg2_0, _arg2_1, _arg1_0, _arg1_1, ctx) {
    const _arg2 = [_arg2_0, _arg2_1];
    const _arg1 = [_arg1_0, _arg1_1];
    ctx.clearRect(_arg2[0], _arg2[1], _arg1[0], _arg1[1]);
    return ctx;
}

export function Context2D_stroke(unitVar0, ctx) {
    ctx.stroke();
    return ctx;
}

export function Context2D_beginPath(unitVar0, ctx) {
    ctx.beginPath();
    return ctx;
}

export function Context2D_strokeStyle(color, ctx) {
    ctx.strokeStyle = color;
    return ctx;
}

export function Context2D_lineJoin(join, ctx) {
    const join_1 = (join.tag === 2) ? "miter" : ((join.tag === 0) ? "bevel" : "round");
    ctx.lineJoin = join_1;
    return ctx;
}

export function Context2D_lineCap(cap, ctx) {
    const cap_1 = (cap.tag === 0) ? "butt" : ((cap.tag === 2) ? "square" : "round");
    ctx.lineCap = cap_1;
    return ctx;
}

function draw(offset, samplesPerFrame, range, data, canvas) {
    iterate((head) => {
        const timeIncrement = (canvas.width * 1) / samplesPerFrame;
        const ctx = canvas.getContext('2d');
        const rest = tail(data);
        const start = toF(offset) * timeIncrement;
        const stop = timeIncrement * toF(1 * data.length);
        void Context2D_beginPath(void 0, Context2D_moveTo(start, head * 1, Context2D_lineCap(new Context2D_LineCap(1), Context2D_lineJoin(new Context2D_LineJoin(1), Context2D_strokeStyle("#080", Context2D_lineWidth(1, ctx))))));
        iterateIndexed((index, sample) => {
            const sample_1 = sample * 1;
            void Context2D_lineTo(timeIncrement * toF((index * 1) + offset), (((range - sample_1) / (2 * range)) * canvas.height) * 1, ctx);
        }, rest);
        void Context2D_stroke(void 0, Context2D_clearRect(start + 1, 0, stop, canvas.height * 1, ctx));
    }, toArray(tryHead(data)));
}

export function fixCanvas(canvas) {
    let arg10, arg10_1;
    const canvasRect = canvas.getBoundingClientRect();
    canvas.setAttribute("width", (arg10 = canvasRect.width, toText(printf("%.0f"))(arg10)));
    canvas.setAttribute("height", (arg10_1 = (canvasRect.height * 0.75), toText(printf("%.0f"))(arg10_1)));
    return canvas;
}

export function tick(sampleRate, _arg1) {
    const scopeState = _arg1;
    const offset = scopeState.offset | 0;
    const data = scopeState.timeDomainData;
    const samplesPerFrame = scopeState.frameDuration * sampleRate;
    const tick_1 = (canvas, chunk) => {
        const used = truncate(toI(samplesPerFrame) - offset, chunk);
        draw(offset, samplesPerFrame, scopeState.range, used, canvas);
        const unused = skip(sampleCount(used), chunk, Float32Array);
        return new ScopeState(scopeState.analyser, scopeState.frameDuration, (sampleCount(unused) > 0) ? 0 : (offset + sampleCount(used)), scopeState.range, scopeState.canvas, unused);
    };
    const matchValue = [scopeState.canvas, offset];
    if (matchValue[0] != null) {
        if (matchValue[1] === 0) {
            const canvas_1 = matchValue[0];
            const trimmed = trimToRisingEdge(toI(samplesPerFrame), data);
            if (sampleCount(trimmed) < 2) {
                return new ScopeState(scopeState.analyser, scopeState.frameDuration, scopeState.offset, scopeState.range, scopeState.canvas, trimmed);
            }
            else {
                return tick_1(canvas_1, trimmed);
            }
        }
        else {
            const canvas_2 = matchValue[0];
            return tick_1(canvas_2, data);
        }
    }
    else {
        return scopeState;
    }
}

